
import enLang from './entries/en-US';
import esLang from './entries/es-ES';
import enRtlLang from './entries/en-US-rtl';
import chLang from './entries/zh-ZH';
import frLang from './entries/fr-FR';
import twLang from './entries/zh-HK';
import miLang from './entries/mi-MI';
import itLang from './entries/it-IT';
import idLang from './entries/id-ID';
import tlLang from './entries/tl-TL';
import viLang from './entries/vi-VI';
import koLang from './entries/ko-KO';
import deLang from './entries/de-DE';
import arLang from './entries/ar-AR';
import ruLang from './entries/ru-RU';
import fiLang from './entries/fi-FI';
import jaLang from './entries/ja-JA';
import thLang from './entries/th_TH';
import nlLang from './entries/nl-NL';
import ptlang from './entries/pt-PT';
import kmLang from './entries/km-KH';
const AppLocale = {
  en: enLang,
  es: esLang,
  enrtl: enRtlLang,
  zh: chLang,
  fr: frLang,
  hk: twLang,
  mi: miLang,
  it: itLang,
  id: idLang,
  tl: tlLang,
  vi: viLang,
  ko: koLang,
  de: deLang,
  ar: arLang,
  pt: ptlang,
  ru: ruLang,
  fi: fiLang,
  ja: jaLang,
  th: thLang,
  nl: nlLang,
  km: kmLang,
};

export default AppLocale;
